import styled from 'styled-components';
import { boxShadow } from 'js/config/style';

export default styled.div`
  position: relative;
  margin-top: 2rem;
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 2rem;
  background: white;
  padding: 2rem;
  border-radius: 0.25rem;
  box-shadow: ${boxShadow};
`;
